import { useEffect, useState } from "react";
import { fetchDataFromApi } from "../utils/api";

const useFetch = (endpoint: any) => {
    interface ApiResponse {
        data: any[]; // Define the actual structure here
        // Add other properties if needed
      }
      
      const [data, setData] = useState<ApiResponse | null>(null);
      // Provide an initial value of null

    useEffect(() => {
        async function fetchData() {
            try {
                const res = await fetchDataFromApi(endpoint);
                setData(res);
            } catch (error) {
                // Handle errors if needed
                console.error("Error fetching data:", error);
            }
        }

        fetchData();
    }, [endpoint]);

    return { data };
};

export default useFetch;
